<template>
	<el-button type="danger" :size="size" @click="DoCancel"><i class="fa fa-ban"></i>&nbsp;删除</el-button>
</template>
<script>
	/**
	* 客户开票删除按钮
	* @author wxq
	* @time 2019.5.23
	* @param infoId 【description: ID,如12】
	*/
	export default {
		name: 'LyBnttonDelete',
		props: {
			infoId: {
				type: String,
				default: ''
			}, 
			size: {
				type: String,
				default: ''
			},
			// 删除完成后的回调函数
			callback: Function 
		},
		methods: {
			DoCancel () {
				this.$confirm('确认要删除本单吗？','删除提醒',{
					confirmButtonText: '确定',
					cancelButtonText: '取消',
          			type: 'warning',
				}).then(() => {
					this.$api.delete('api/customerinvoiceinfo/' + this.infoId).then((rs) => {
						// this.isdisabled = true
						this.$message({
				            type: 'success',
				            message: '本单已被成功删除.'
				        })
				        // 调用回调函数
				        this.callback()
					}).catch((msg) => {
						this.$alert(msg,'单据删除提醒',{
							confirmButtonText: '确定',
		          			callback: action => {
					          	this.$message({
						            type: 'info',
						            message: '本单删除操作失效'
						        })  
					        }
						})
					})
				}).catch(() => {
					this.$message({
			            type: 'info',
			            message: '已取消本单作废操作！'
			        })  
				})
			}
		}
	}
</script>